/**
 * Cookie Cleanup Script
 * Clears non-essential marketing and analytics cookies (Google Analytics, Meta/Facebook Pixel, etc.)
 * when a user updates their consent choices to "Decline" via Shopify's Customer Privacy API.
 */
(function () {
  'use strict';

  // Patterns for marketing and analytics cookies
  var MARKETING_ANALYTICS_COOKIE_PATTERNS = [
    /^_ga($|_)/i,          // _ga, _ga_XXXXXX (Google Analytics 4)
    /^_gid$/i,             // _gid (Universal Analytics)
    /^_gat($|_)/i,         // _gat, _gat_XXXXXX (Google Analytics throttling)
    /^_gcl_/i,             // _gcl_au, _gcl_aw (Google Ads / Click)
    /^_gac_/i,             // _gac_XXXXXX (Google Ads)
    /^_fbp$/i,             // Meta / Facebook Pixel
    /^_fbc$/i,             // Meta / Facebook Click
    /^fr$/i,               // Meta / Facebook
    /^_pin_/i,             // Pinterest
    /^_pinterest_/i,       // Pinterest
    /^_tt_/i,              // TikTok
    /^_uet/i               // Microsoft / Bing UET
  ];

  function getCookieNames() {
    return document.cookie
      .split(';')
      .map(function (c) {
        return c.trim().split('=')[0];
      })
      .filter(Boolean);
  }

  function deleteCookie(name) {
    var host = window.location.hostname;
    var hostParts = host.split('.');
    var domains = ['', host, '.' + host];

    // Handle root / parent domains (e.g. .kascomarine.com)
    for (var i = 1; i < hostParts.length; i++) {
      var parent = hostParts.slice(i).join('.');
      if (parent.indexOf('.') !== -1) {
        domains.push(parent);
        domains.push('.' + parent);
      }
    }

    var paths = ['/', window.location.pathname];
    var isHttps = window.location.protocol === 'https:';

    domains.forEach(function (domain) {
      paths.forEach(function (path) {
        var base = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + path + ';';
        if (domain) {
          base += ' domain=' + domain + ';';
        }
        document.cookie = base;
        if (isHttps) {
          document.cookie = base + ' Secure;';
        }
      });
    });
  }

  function clearTrackingCookies() {
    var cookies = getCookieNames();
    var deleted = [];

    cookies.forEach(function (name) {
      var matches = MARKETING_ANALYTICS_COOKIE_PATTERNS.some(function (pattern) {
        return pattern.test(name);
      });

      if (matches) {
        deleteCookie(name);
        deleted.push(name);
      }
    });

    // In-memory consent revocation so loaded scripts do not immediately re-write cookies
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('consent', 'update', {
          analytics_storage: 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied'
        });
      } catch (e) {}
    }

    if (typeof window.fbq === 'function') {
      try {
        window.fbq('consent', 'revoke');
      } catch (e) {}
    }

    if (deleted.length > 0) {
      console.info('[CookieCleanup] Cleared non-consented tracking cookies:', deleted);
    }
  }

  // Expose globally for manual testing in console: window.clearTrackingCookies()
  window.clearTrackingCookies = clearTrackingCookies;

  function isConsentDenied(detail) {
    if (!detail) return false;
    if (typeof detail === 'boolean') return detail === false;

    var visitorConsent = detail.visitorConsent || detail;

    var analyticsDenied =
      visitorConsent.analytics === false ||
      visitorConsent.analytics === 'no' ||
      visitorConsent.analyticsProcessingAllowed === false;

    var marketingDenied =
      visitorConsent.marketing === false ||
      visitorConsent.marketing === 'no' ||
      visitorConsent.marketingAllowed === false;

    return analyticsDenied || marketingDenied;
  }

  function handleConsentUpdate(event) {
    var detail = event ? event.detail : null;
    var denied = false;

    if (detail) {
      denied = isConsentDenied(detail);
    }

    // Also check Shopify customerPrivacy API directly if available
    if (window.Shopify && window.Shopify.customerPrivacy) {
      var cp = window.Shopify.customerPrivacy;
      if (typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) {
        denied = true;
      }
      if (typeof cp.marketingAllowed === 'function' && !cp.marketingAllowed()) {
        denied = true;
      }
      if (typeof cp.userCanBeTracked === 'function' && !cp.userCanBeTracked()) {
        if (typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() === 'no') {
          denied = true;
        }
      }
    }

    if (denied) {
      clearTrackingCookies();
    }
  }

  // Listen for Shopify Customer Privacy DOM events
  document.addEventListener('visitorConsentCollected', handleConsentUpdate);
  window.addEventListener('visitorConsentCollected', handleConsentUpdate);
  document.addEventListener('visitorConsentUpdated', handleConsentUpdate);

  // Initialize and check status on load using Shopify features loader
  function initPrivacyApi() {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: function () {
            if (window.Shopify && window.Shopify.customerPrivacy) {
              var cp = window.Shopify.customerPrivacy;

              if (typeof cp.subscribe === 'function') {
                cp.subscribe('visitorConsentCollected', handleConsentUpdate);
              }

              // Check existing consent state on load (if previously declined)
              var isDeclined = false;
              if (typeof cp.getTrackingConsent === 'function') {
                var consent = cp.getTrackingConsent();
                if (consent === 'no' || consent === 'declined') {
                  isDeclined = true;
                }
              }

              if (typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) {
                if (typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() !== 'no_interaction') {
                  isDeclined = true;
                }
              }

              if (isDeclined) {
                clearTrackingCookies();
              }
            }
          }
        }
      ]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrivacyApi);
  } else {
    initPrivacyApi();
  }
})();

